/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, forwardRef, } from '@angular/core';
import { CheckboxRequiredValidator, NG_VALIDATORS, } from '@angular/forms';
export const /** @type {?} */ _MatCheckboxRequiredValidator = CheckboxRequiredValidator;
export const /** @type {?} */ MAT_CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => MatCheckboxRequiredValidator),
    multi: true
};
/**
 * Validator for Material checkbox's required attribute in template-driven checkbox.
 * Current CheckboxRequiredValidator only work with `input type=checkbox` and does not
 * work with `mat-checkbox`.
 */
export class MatCheckboxRequiredValidator extends _MatCheckboxRequiredValidator {
}
MatCheckboxRequiredValidator.decorators = [
    { type: Directive, args: [{
                selector: `mat-checkbox[required][formControlName],
             mat-checkbox[required][formControl], mat-checkbox[required][ngModel]`,
                providers: [MAT_CHECKBOX_REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
MatCheckboxRequiredValidator.ctorParameters = () => [];
function MatCheckboxRequiredValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    MatCheckboxRequiredValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatCheckboxRequiredValidator.ctorParameters;
}
//# sourceMappingURL=checkbox-required-validator.js.map